import { FC, useMemo } from "react"

import { css } from "@emotion/react"

import { Box, BoxProps } from "../layout"
import { LoadingSpinner } from "./LoadingSpinner"

export interface LoadingWrapperProps extends BoxProps {
	isLoading: boolean
}

export const LoadingWrapper: FC<LoadingWrapperProps> = ({ isLoading, children, ...rest }) => {
	const childrenContainerStyle = useMemo(() => {
		return css`
			position: relative;
			display: inline-block;
			opacity: ${isLoading ? 0.5 : 1};
			pointer-events: ${isLoading ? "none" : undefined};
			cursor: ${isLoading ? "pointer" : undefined};
		`
	}, [isLoading])

	return (
		<Box {...rest}>
			<div css={childrenContainerStyle}>
				{isLoading && (
					<div css={spinnerContainerStyle}>
						<LoadingSpinner py={0} />
					</div>
				)}
				{children}
			</div>
		</Box>
	)
}

const spinnerContainerStyle = css`
	position: absolute;
	display: flex;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	align-items: center;
	justify-content: center;
`
